<template>
  <div class="social-image-slider">
    <b-modal v-model="showRemoveImage" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveImage" ok-title="Yes, Delete">
      <p>Are you sure you want to delete this image?</p>
    </b-modal>
    <b-modal 
      v-model="showImagePopup" 
      size="lg"
      modal-class="image-slider-popup-modal"
    >
      <img :src="`${apiUrl}viewFileSocialMediaPost/${socialPost.id}/${modalImageId}/${token}`" class="post-image-popup" />
      <template #modal-footer="{ ok, cancel, hide }">
        <span></span>
      </template>
    </b-modal>
    <b-modal
      id="image-thumbnail-popup-modal"
      v-model="showImageEditorPopup"
      size="lg"
      modal-class="image-editor-popup-modal"
      >
      <img :src="`${apiUrl}viewFileSocialMediaPost/${socialPost.id}/${modalImageId}/${token}`" class="post-image-popup" />
      <template #modal-footer="{ ok, cancel, hide }">
        <div class="image-alt">
          <label :for="'image-alt-'+modalImageId">Image Alt Text</label>
          <input :name="'image-alt-'+modalImageId" type="text" placeholder="Enter image alt text" class="image-alt-input" :class="altTextClass(modalImageAlt)" v-model="modalImageAlt" :disabled="altDisabled" @blur="imageAltTextUpdated" ref="altTextInput" />
          <button title="Delete Image" class="btn delete-deliverable-btn" @click="deleteImageClicked"><i class="fas fa-trash-alt"></i></button>
        </div>
      </template>
    </b-modal>
    <div class="swiper" v-show="socialPost.files.length > 1" :id="getSliderId">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="file in socialPost.files">
          <div class="image-wrap">
            <span v-if="!isEditor" class="expand-image-icon" :data-fileid="file.id" @click="expandImage">
              <i class="fas fa-expand-arrows-alt"></i>
            </span>
            <img :src="`${apiUrl}viewFileSocialMediaPost/${file.social_post_id}/${file.id}/${token}`" />
          </div>
          <div class="alt-text-wrap" :class="altTextClass(file.alt_text)">
            <span class="alt-text">{{ imageAltText(file.alt_text) }}</span>
            <img v-if="isEditor" :data-fileid="file.id" :data-filealt="file.alt_text" class="edit-image-icon" src="/images/pencil.svg" @click="editImage" />
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <div class="single-image" v-if="socialPost.files.length <= 1" v-for="file in socialPost.files">
      <div class="image-wrap">
        <span v-if="!isEditor" class="expand-image-icon" :data-fileid="file.id" @click="expandImage">
          <i class="fas fa-expand-arrows-alt"></i>
        </span>
        <img :src="`${apiUrl}viewFileSocialMediaPost/${file.social_post_id}/${file.id}/${token}`" />
      </div>
      <div class="alt-text-wrap" :class="altTextClass(file.alt_text)">
        <span class="alt-text">{{ imageAltText(file.alt_text) }}</span>
        <img v-if="isEditor" :data-fileid="file.id" :data-filealt="file.alt_text" class="edit-image-icon" src="/images/pencil.svg" @click="editImage" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// for some reason neither "swiper/vue" as per swiperjs's vue documentation or "swiper/vue/swiper-vue" as suggested by a stackoverflow question worked
import { Swiper, Navigation, Pagination } from 'swiper';

import "swiper/swiper-bundle.css";
import { watch, ref } from 'vue';

export default {
  data() {
    return {
      swiper: false,
      showImagePopup: false,
      showImageEditorPopup: false,
      showRemoveImage: false,
      modalImageId: false,
      modalImageAlt: "",
      modalImageAltInit: "",
      altDisabled: false,
    }
  },
  components: {
    Swiper,
    Navigation,
    Pagination,
  },
  props: ['socialPost', 'location', 'isEditor'],
  computed: {
    ...mapGetters([
      "systemSettings",
    ]),
    token(){
      return this.$store.getters.authToken;
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    getSliderId() {
      return this.location+"-image-slider-"+this.socialPost.id;
    },
  },
  methods: {
    imageAltText(imageText) {
      if(!imageText){
        if(!this.isEditor){
          return "No alt text"
        } else {
          return "No alt text, click thumbnail to edit"
        }
      }
      return imageText;
    },
    getSocialNetworkSlugFromId(network_id){
      let network = this.systemSettings.social_networks.filter(network => network.id === network_id)[0];
      return network.api_type;
    },
    altTextClass(altText) {
      if(altText){
        if(altText.length){
          return {};
        }
      }
      return {
        "no-alt": true
      };
    },
    expandImage(e){
      this.modalImageId = e.currentTarget.dataset.fileid;
      this.showImagePopup = true;
    },
    editImage(e){
      console.log("edit image alt clicked");
      console.log(e.currentTarget.dataset);
      this.modalImageId = e.currentTarget.dataset.fileid;
      this.modalImageAlt = e.currentTarget.dataset.filealt;
      this.modalImageAltInit = this.modalImageAlt;
      this.showImageEditorPopup = true;
      let that = this;

      if(this.modalImageAlt == ""){
        let altCheck = setInterval(function(){
          console.log("tick");
          let altText = that.$refs.altTextInput;
          if(altText){
            altText.focus();
            clearInterval(altCheck);
          }
        }, 100);
      }
    },
    imageAltTextUpdated(e){
      if(this.modalImageAlt === this.modalImageAltInit){
        return;
      }
      this.altDisabled = true;
      let that = this;
      this.$store.dispatch("updateFileAltTextSocialMediaPost",
      {
        id: this.socialPost.id,
        file_id: [this.modalImageId],
        value: e.target.value
      }).then(function(){
        that.altDisabled = false;
      });
    },
    deleteImageClicked(e){
      e.preventDefault();
      this.showRemoveImage = true;
    },
    onConfirmRemoveImage(){
      this.$store.dispatch("removeFileSocialMediaPost", {
        id: this.socialPost.id,
        file_id: [this.modalImageId]
      });
      this.showImageEditorPopup = false;
    },
    createSlider(){
      this.swiper = new Swiper('#'+this.getSliderId, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        speed: 300,
        spaceBetween: 0,
        rewind: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      });
    },
    initSlider(){
      this.swiper.init('#'+this.getSliderId);
    }
  },
  mounted(){
    this.createSlider();
    let self = this;
  },
  watch: {
    socialPost(to, from){
      let self = this;
      this.$nextTick(function () {
        self.swiper.update();
      });
      /*
      if(to.files.length > 1 && from.files.length <= 1){
        console.log("need to create slider");
        this.createSlider();
        this.initSlider();
      }

      if(to.files.length <=1 && from.files.length > 1){
        console.log("need to destroy slider");
        this.swiper.destroy();
      }

      if(to.files.length > 1 && from.files.length > 1){
        console.log("need to reinitialize slider");
        this.swiper.update()
      }
      */
      
    }
  },
};


</script>